import React, { useState, useEffect, useMemo, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import Toastr from "../../components/common/Toastr";
import swal from "sweetalert";
import {
  restApi,
  restApi_PD,
} from "../../../services/wooCommerceRestApi/restApi";
import { Button } from "react-bootstrap";
import PageTitle from "../../layouts/PageTitle";
// import Table from "../../components/table/ReactTable/Table";
import ProductTable from "../../components/table/ReactTable/ProductTable";

import { ColumnFilter } from "../../components/table/ReactTable/ColumnFilter";
import { Badge } from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import { productActions } from "../../../_store";

import generatePDF from "../../components/export/generatePDF";
import generateXlsx from "../../components/export/generateXlsx";
import useFullPageLoader from "../../../hooks/useFullPageLoader";
import CommonService from "../../../services/Common/CommonService";
import { HandleArchiveProduct } from "./HandleArchiveProduct";

const ProductList = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [loader, showLoader, hideLoader] = useFullPageLoader();
  // #region ------------------  Reducer --------------------------------

  const currentUser = useSelector((x) => x.auth.user);
  const productList = useSelector((x) => x.product.productList);
  const productResponse = useSelector((x) => x.product.productResponse);
  const deleteProductResponse = useSelector(
    (x) => x.product.deleteProductResponse,
  );
  const isLoading = useSelector((x) => x.product.isLoading);
  const [viewFilter, setviewFilter] = useState([]);
  const [finalTableData, setFinalTableData] = useState([]);
  const handleTableDataUpdate = useCallback((data) => {
    setFinalTableData(data);
  }, []);
  // #endregion ------------------  Reducer End --------------------------------
  // console.log("viewFilter",viewFilter)

  useEffect(() => {
    const storeValues = JSON.parse(localStorage.getItem("storeValues")) || [];

    if (storeValues.length > 0 || isLoading) {
      showLoader();
    } else {
      hideLoader();
    }
  }, [isLoading]); // Runs when isLoading changes

  const PRODUCTS_COLUMNS = [
    {
      Header: "Warehouse",
      Footer: "Warehouse",
      accessor: "WareHouseNumber",
      justify: "center",
      Filter: ColumnFilter,
    },
    {
      Header: "Category",
      Footer: "Category",
      accessor: "CategoryName",
      justify: "left",
      Filter: ColumnFilter,
    },

    {
      Header: "Product Name",
      Footer: "Product Name",
      accessor: "ProductName",
      justify: "left",
      Filter: ColumnFilter,
    },
    {
      Header: "SKU",
      Footer: "SKU",
      accessor: "SKU",
      justify: "left",
      Filter: ColumnFilter,
    },

    {
      Header: "Package type",
      Footer: "Package type",
      accessor: "PackageType",
      justify: "left",
      Filter: ColumnFilter,
    },
    {
      Header: "Location",
      Footer: "Location",
      accessor: "Location",
      justify: "left",
      Filter: ColumnFilter,
    },
    {
      Header: "stock Quantity",
      Footer: "stock Quantity",
      accessor: "StockQuantityStr",
      justify: "center",
      fieldType: "commaSeparator",

      Cell: ({ row }) => {
        return (
          <>
            <div>
              {row.original.StockQuantity <= 0 ? (
                <Badge
                  variant="danger"
                  style={{ background: "#e42313", border: "#e42313" }}
                >
                  {row.original.StockQuantityStr}
                </Badge>
              ) : (
                <Badge
                  variant="success"
                  style={{ background: "#48A23F", border: "#48A23F" }}
                >
                  {row.original.StockQuantityStr}
                </Badge>
              )}
            </div>
          </>
        );
      },
      Filter: ColumnFilter,
    },

    {
      Header: "Created Date",
      Footer: "Created Date",
      accessor: "CreatedDateString",
      fieldType: "Date",
      // Cell: ({ value }) => { return format(new Date(value), 'MM/dd/yyyy') },
      justify: "left",
      Filter: ColumnFilter,
    },
    {
      Header: "Website",
      Footer: "Website",
      accessor: "Woocommerce",
      justify: "left",
      Filter: ColumnFilter,
    },

    // {
    //     Header: 'Active',
    //     Footer: 'Active',
    //     accessor: 'Active',
    //     Cell: ({ value }) => {
    //         return <>
    //             <Badge variant="primary light badge-lg"> {value}</Badge>
    //         </>

    //     },
    //     Filter: ColumnFilter,
    // },
    {
      Header: "",
      Footer: "",
      accessor: "ProductID",
      disableFilters: true,
      Cell: ({ row }) => {
        if (currentUser.UserTypeID === 3) return null;
        return (
          <>
            <div className="d-flex">
              <div
                onClick={() => handleEditClick(row.original)}
                title={currentUser.UserTypeID === 8 ? "View" : "Edit"}
                className="btn btn-primary shadow btn-xs sharp me-1"
              >
                <i
                  className={
                    currentUser.UserTypeID === 8 ? "fas fa-eye" : "fas fa-pen"
                  }
                ></i>
              </div>
              {row.original?.StockQuantity === 0 &&
                currentUser.UserTypeID !== 8 && (
                  <div
                    onClick={() => handleDeleteClick(row.original)}
                    className="btn btn-danger shadow btn-xs sharp"
                    title="Delete"
                  >
                    <i className="fa fa-trash"></i>
                  </div>
                )}
              {currentUser.UserTypeID !== 8 && (
                <div
                  onClick={() => handleArchive(row.original)}
                  className="btn shadow btn-xs sharp"
                  title="Archive"
                  style={{ backgroundColor: "#B0BEC5", color: "#5d5757" }}
                >
                  <i className="fa fa-archive"></i>
                </div>
              )}
              {/* <a
                            onClick={() => handleWMSDeleteClick(row.original)}
                            className="btn  shadow btn-xs sharp" title="WMSDelete"
                        >
                            <i className="fa fa-trash" ></i>
                        </a> */}
            </div>
          </>
        );
      },
    },
  ];

  const columns = PRODUCTS_COLUMNS;

  const generateColumns = [
    {
      header: "Warehouse",
      dataKey: "WareHouseNumber",
      cellWidth: 16,
    },
    {
      header: "Category",
      dataKey: "CategoryName",
      cellWidth: 40,
    },
    {
      header: "Product Name",
      dataKey: "ProductName",
      cellWidth: 40,
    },
    {
      header: "SKU",
      dataKey: "SKU",
      cellWidth: 40,
    },
    {
      header: "Package Type",
      dataKey: "PackageType",
      cellWidth: 30,
    },
    {
      header: "Location",
      dataKey: "Location",
      cellWidth: 25,
    },
    {
      header: "Stock Quantity",
      dataKey: "StockQuantityStr",
      cellWidth: 30,
    },
    {
      header: "Created Date",
      dataKey: "CreatedDateString",
      cellWidth: 25,
    },
    {
      header: "Website",
      dataKey: "Woocommerce",
      cellWidth: 30,
    },
  ];

  useEffect(() => {
    showLoader();
    if (productResponse === 1) {
      Toastr("Product saved successfully", "success");
    } else if (productResponse === 2) {
      Toastr("Product updated successfully", "success");
    }
    dispatch(productActions.getProductAll(startEndDate));
  }, [dispatch]);

  // const handleRangeDateSearch = () => {
  //     showLoader();
  //     if (startEndDate.FromDate && startEndDate.ToDate) {
  //         dispatch(productActions.getProductAll(startEndDate));
  //     } else {
  //         hideLoader();
  //         Toastr("Please select the end date", "warning");
  //     }
  // };
  useEffect(() => {
    if (isLoading) {
      hideLoader();
    }
  }, [isLoading]);

  // const onChangeRangeValue =
  //     (title) =>
  //         (...date) => {
  //             let value = { ...startEndDate };
  //             value.FromDate = date[0];
  //             value.ToDate = date[1];
  //             setStartEndDate(value);
  //         };

  const [startEndDate, setStartEndDate] = useState({
    FromDate: new Date(),
    ToDate: new Date(),
    Status: 0,
  });

  useEffect(() => {
    const clearFiltersOnRefresh = () => {
      localStorage.removeItem("storeValues");
    };

    window.addEventListener("beforeunload", clearFiltersOnRefresh);
    return () => {
      window.removeEventListener("beforeunload", clearFiltersOnRefresh);
    };
  }, []);

  const handleEditClick = (productDetail) => {
    if (viewFilter.length > 0) {
      localStorage.setItem(`storeValues`, JSON.stringify(viewFilter));
    } else {
      console.log("viewFilter is empty inside the function");
    }

    const data = { ProductID: productDetail.ProductID };
    navigate("/CreateProduct", {
      state: data,
    });
  };

  // const clearSession = () =>{
  //   if(localStorage.getItem('storedValues')){
  //     localStorage.removeItem('storedValues');
  //   }
  // }

  const handleGetFilter = (id) => {
    setviewFilter([...id]);
    // localStorage.setItem(`storedValues`, JSON.stringify(viewFilter));
  };

  //products
  const handleDeleteClick = (values) => {
    swal({
      title: "Confirm to delete this item..?",
      text: "",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        showLoader();
        let Param = { DeleteID: values.ProductID, DeleteType: 5 };
        CommonService.CheckMappedItem(Param).then((res) => {
          if (res.data === 1) {
            if (values.IsGemar === true && values.IsPartyDeco === true) {
              //Gemar API
              restApi
                .delete("products/" + values.WCProductID, {
                  force: true,
                })
                .then((response) => {
                  console.log(response.data);
                  if (
                    response.status === 200 ||
                    response.status === 201 ||
                    !response.statusText
                  ) {
                    //Party Deco API
                    restApi_PD
                      .delete("products/" + values.PDWCProductID, {
                        force: true,
                      })
                      .then((PDResponse) => {
                        if (
                          PDResponse.status === 200 ||
                          PDResponse.status === 201 ||
                          !PDResponse.statusText
                        ) {
                          // Core API
                          dispatch(
                            productActions.deleteProduct({
                              ProductID: values.ProductID,
                              DeletedBy: currentUser.Id,
                            }),
                          );
                        } else {
                          Toastr(response.statusText, "warning");
                          hideLoader();
                        }
                      })
                      .catch((error) => {
                        hideLoader();
                        Toastr(
                          error.response
                            ? error.response.data.message
                            : "rest Api error",
                          "warning",
                        );
                        console.log(error.response && error.response.data);
                      });
                  } else {
                    Toastr("This Product is already mapped", "warning");
                    hideLoader();
                  }
                })
                .catch((error) => {
                  hideLoader();
                  Toastr(
                    error.response
                      ? error.response.data.message
                      : "rest Api error",
                    "warning",
                  );
                  console.log(error.response && error.response.data);
                });
            } else if (values.IsGemar === true) {
              // Gemar API
              restApi
                .delete("products/" + values.WCProductID, {
                  force: true,
                })
                .then((response) => {
                  console.log(response.data);
                  if (
                    response.status === 200 ||
                    response.status === 201 ||
                    !response.statusText
                  ) {
                    // Core API
                    dispatch(
                      productActions.deleteProduct({
                        ProductID: values.ProductID,
                        DeletedBy: currentUser.Id,
                      }),
                    );
                  } else {
                    Toastr(response.statusText, "warning");
                    hideLoader();
                  }
                })
                .catch((error) => {
                  hideLoader();
                  Toastr(
                    error.response
                      ? error.response.data.message
                      : "rest Api error",
                    "warning",
                  );
                  console.log(error.response && error.response.data);
                });
            } else if (values.IsPartyDeco === true) {
              // Party Deco API
              restApi_PD
                .delete("products/" + values.PDWCProductID, {
                  force: true,
                })
                .then((response) => {
                  console.log(response.data);
                  if (
                    response.status === 200 ||
                    response.status === 201 ||
                    !response.statusText
                  ) {
                    // Core API
                    dispatch(
                      productActions.deleteProduct({
                        ProductID: values.ProductID,
                        DeletedBy: currentUser.Id,
                      }),
                    );
                  } else {
                    Toastr(response.statusText, "warning");
                    hideLoader();
                  }
                })
                .catch((error) => {
                  hideLoader();
                  Toastr(
                    error.response
                      ? error.response.data.message
                      : "rest Api error",
                    "warning",
                  );
                  console.log(error.response && error.response.data);
                });
            }
          } else {
            Toastr("This Product is already mapped", "warning");
            hideLoader();
          }
        });
      }
    });
  };

  /* Add product to archived list */
  const handleArchive = (values) => {
    HandleArchiveProduct(
      values,
      startEndDate,
      "Are you sure want to Archive this Product ?",
      "draft",
      dispatch,
      showLoader,
      hideLoader,
      4,
    );
  };

  // const handleArchive = (values) => {
  //   swal({
  //     title: "Warning: You have archived this item..?",
  //     text: "",
  //     icon: "warning",
  //     buttons: true,
  //     dangerMode: true,
  //   }).then((res) => {
  //     if (res) {
  //       showLoader();
  //       const ApiData = {
  //         status: "draft",
  //       };

  //       if (values.IsGemar === true && values.IsPartyDeco === true) {
  //         UpdateProductGemarAndPA(values, ApiData);
  //       } else if (values.IsGemar === true) {
  //         UpdateProductGemar(values, ApiData);
  //       } else if (values.IsPartyDeco === true) {
  //         UpdateProductPA(values, ApiData);
  //       } else {
  //         hideLoader();
  //         Toastr("Data error", "warning");
  //       }
  //     }
  //   });
  // };

  // function UpdateProductGemar(values, ApiData) {
  //   restApi
  //     .post("products/" + values.WCProductID, ApiData)
  //     .then((response) => {
  //       console.log(response.data);
  //       if (
  //         response.status === 200 ||
  //         response.status === 201 ||
  //         !response.statusText
  //       ) {
  //         dispatch(productActions.handleArchive(values?.ProductID));
  //         dispatch(productActions.getProductAll(startEndDate));
  //         Toastr("Product has been successfully archived", "success");
  //         hideLoader();
  //       } else {
  //         hideLoader();
  //         Toastr("Gemar : " + response.statusText, "warning");
  //       }
  //     })
  //     .catch((error) => {
  //       hideLoader();

  //       let msg = "";
  //       if (error.response) {
  //         if (error.response.data.code === "products_exists") {
  //           msg = "";
  //         } else {
  //           msg = error.response.data.message;
  //         }
  //       } else {
  //         msg = "rest Api error";
  //       }

  //       Toastr("Gemar : " + msg, "warning");
  //       console.log();
  //     });
  // }

  // function UpdateProductPA(values, ApiData) {
  //   restApi_PD
  //     .post("products/" + values.PDWCProductID, ApiData)
  //     .then((response) => {
  //       if (
  //         response.status === 200 ||
  //         response.status === 201 ||
  //         !response.statusText
  //       ) {
  //         dispatch(productActions.handleArchive(values?.ProductID));
  //         dispatch(productActions.getProductAll(startEndDate));
  //         Toastr("Product has been successfully archived", "success");
  //         hideLoader();
  //       } else {
  //         hideLoader();
  //         Toastr("PartyDeco : " + response.statusText, "warning");
  //       }
  //     })
  //     .catch((error) => {
  //       hideLoader();

  //       let msg = "";
  //       if (error.response) {
  //         if (error.response.data.code === "products_exists") {
  //           msg = "";
  //         } else {
  //           msg = error.response.data.message;
  //         }
  //       } else {
  //         msg = "rest Api error";
  //       }

  //       Toastr("PartyDeco : " + msg, "warning");
  //       console.log();
  //     });
  // }

  // function UpdateProductGemarAndPA(values, ApiData) {
  //   restApi
  //     .post("products/" + values.WCProductID, ApiData)
  //     .then((response) => {
  //       console.log(response.data);
  //       if (
  //         response.status === 200 ||
  //         response.status === 201 ||
  //         !response.statusText
  //       ) {
  //         restApi_PD
  //           .post("products/" + values.PDWCProductID, ApiData)
  //           .then((PDResponse) => {
  //             console.log(PDResponse.data);
  //             if (
  //               PDResponse.status === 200 ||
  //               PDResponse.status === 201 ||
  //               !PDResponse.statusText
  //             ) {
  //               dispatch(productActions.handleArchive(values?.ProductID));
  //               dispatch(productActions.getProductAll(startEndDate));
  //               Toastr("Product has been successfully archived", "success");
  //               hideLoader();
  //             } else {
  //               hideLoader();
  //               Toastr("PartyDeco : " + PDResponse.statusText, "warning");
  //             }
  //           })
  //           .catch((error) => {
  //             hideLoader();

  //             let msg = "";
  //             if (error.response) {
  //               if (error.response.data.code === "products_exists") {
  //                 msg = "";
  //               } else {
  //                 msg = error.response.data.message;
  //               }
  //             } else {
  //               msg = "rest Api error";
  //             }

  //             Toastr("PartyDeco : " + msg, "warning");
  //           });
  //       } else {
  //         hideLoader();
  //         Toastr("Gemar : " + response.statusText, "warning");
  //       }
  //     })
  //     .catch((error) => {
  //       hideLoader();

  //       let msg = "";
  //       if (error.response) {
  //         if (error.response.data.code === "products_exists") {
  //           msg = "";
  //         } else {
  //           msg = error.response.data.message;
  //         }
  //       } else {
  //         msg = "rest Api error";
  //       }

  //       Toastr("Gemar : " + msg, "warning");
  //       console.log();
  //     });
  // }

  const handleWMSDeleteClick = (values) => {
    swal({
      title: "Are you sure, you want to WMSdelete this Product?",
      text: "",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        showLoader();
        let Param = { DeleteID: values.ProductID, DeleteType: 5 };

        CommonService.CheckMappedItem(Param).then((response) => {
          if (response.data) {
            // dispatch(productActions.deleteProduct({ DeleteID: values.ProductID, DeletedBy: currentUser.Id }));
            dispatch(
              productActions.deleteProduct({
                ProductID: values.ProductID,
                DeletedBy: currentUser.Id,
              }),
            );
          } else {
            Toastr("This Vendor is already mapped", "warning");
            hideLoader();
          }
        });
      }
    });
  };

  // handleDeleteClick
  useEffect(() => {
    if (deleteProductResponse === 1) {
      hideLoader();
      Toastr("Successfully Deleted", "success");
      dispatch(productActions.getProductAll(startEndDate));
    } else if (deleteProductResponse === -1) {
      hideLoader();
      Toastr("Error ", "warning");
    } else {
      // hideLoader();
    }
  }, [deleteProductResponse]);

  const handleAddProduct = () => {
    navigate("/CreateProduct");
  };

  ///  export  //
  const handleClickPDF = () => {
    let title = "Product List";
    const columnStyles = {
      WareHouseNumber: { halign: "center", cellWidth: 16 },
      CategoryName: { halign: "left", cellWidth: 40 },
      ProductName: { halign: "left", cellWidth: 40 },
      SKU: { halign: "left", cellWidth: 40 },
      PackageType: { halign: "left", cellWidth: 30 },
      Location: { halign: "left", cellWidth: 25 },
      StockQuantityStr: { halign: "center", cellWidth: 30 },
      CreatedDateString: { halign: "left", cellWidth: 25 },
      Woocommerce: { halign: "left", cellWidth: 30 },
    };

    generatePDF(finalTableData, generateColumns, true, title, columnStyles);
  };

  const handleClickExcel = () => {
    let title = "Product";
    let generateExcelColumns = [
      "Warehouse",
      "Category",
      "Product Name",
      "SKU",
      "Package type",
      "Location",
      "Stock Quantity",
      "Created Date",
      "Website",
    ];
    let new_productList =
      finalTableData &&
      finalTableData.map(function (obj) {
        return {
          WareHouseNumber: obj.WareHouseNumber,
          CategoryName: obj.CategoryName,
          ProductName: obj.ProductName,
          SKU: obj.SKU,
          PackageType: obj.PackageType,
          Location: obj.Location,
          StockQuantity: obj.StockQuantityStr,
          CreatedDateString: obj.CreatedDateString,
          Woocommerce: obj.Woocommerce,
        };
      });

    generateXlsx(new_productList, generateExcelColumns, title);
  };

  return (
    <>
      <PageTitle activeMenu="Product Details" motherMenu="Products" />
      <ToastContainer />
      {loader}
      <div className="card">
        <div className="card-header">
          <h4 className="card-title header-title">Product List</h4>
          {currentUser.UserTypeID !== 3 && (
            <div className="float-sm-end">
              <Button
                className="me-2"
                variant="danger btn-rounded"
                onClick={handleClickPDF}
              >
                <span className="btn-icon-start text-danger">
                  <i className="fa fa-solid fa-file-pdf"></i>
                </span>
                PDF
              </Button>
              <Button
                className="me-2"
                variant="secondary btn-rounded"
                onClick={handleClickExcel}
              >
                <span className="btn-icon-start text-secondary">
                  <i className="fa fa-regular fa-file-excel"></i>
                </span>
                Excel
              </Button>
              {currentUser.UserTypeID !== 8 && (
                <Button
                  className="me-2"
                  variant="primary btn-rounded"
                  onClick={handleAddProduct}
                >
                  <span className="btn-icon-start text-primary">
                    <i className="fa fa-plus color-info" />
                  </span>
                  Add
                </Button>
              )}
            </div>
          )}
        </div>
        <div className="card-body">
          {/* <div className="row"> */}
          {/* <div className="col-lg-3 col-md-8 mb-3">
                            <div className="example rangeDatePicker ms-2">
                            <p className="mb-1 text-black font-w500 productDate">Product Date Range</p>
                            <RangeDatePicker
                            initialStartDate={startEndDate.FromDate ? startEndDate.FromDate : new Date()}
                            initialEndDate={startEndDate.ToDate ? startEndDate.ToDate : new Date()}
                            name="StartEndDate"
                            startText="Start"
                            endText="End"
                            dateFormat="MM/DD/YYYY"
                            startPlaceholder="Start Date"
                            endPlaceholder="End Date"
                            portal
                            onChange={onChangeRangeValue("date")}
                            
                            />
                            </div>
                            </div> */}
          {/* <div className="col-md-3 mb-2"> */}
          {/* <div className="d-flex mt-5"> */}
          {/* <a className="btn btn-primary shadow btn-xs sharp me-1" title="Search" onClick={() => handleRangeDateSearch()} >
                                    <i className="fas fa-search"></i>
                                    </a> */}
          {/* <a className="btn btn-danger shadow btn-xs sharp" title="Delete" onClick={() => handleRangeDateClear()} >
                                    <i className="fas fa-times"></i></a> */}
          {/* </div> */}
          {/* </div> */}

          {/* </div> */}
          {/* {showInitialLoader ? loader : <ProductTable columns={columns} data={productList} getFilterValue={(id)=>handleGetFilter(id)}/>} */}
          <ProductTable
            columns={columns}
            data={productList}
            getFilterValue={(id) => handleGetFilter(id)}
            onDataUpdate={handleTableDataUpdate}
          />
        </div>
      </div>

      {loader}
    </>
  );
};

export default ProductList;
